import React from 'react';
import { ArrowLeftIcon } from 'icons';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { openAuthModal, setRequiredModal } from 'modules/auth';
import { useLessons } from 'modules/lesson-detail';

import { VideoPlayer, Visible } from 'components';

import { useCourseBySlug } from '../hooks';

import Skeleton from './course-contents/skeleton';
import { CourseContents } from './course-contents';
import FirstSection from './first-section';
import { Payment } from './payment';

export const CourseDetail = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { query, push, asPath, back } = useRouter();
  const isAuth = useAppSelector(({ user }) => user?.phone);
  const { course } = useCourseBySlug(query?.course as string);
  const { lessons, isLoading } = useLessons(query?.course as string);

  const onEnterLesson = () => {
    if (!isAuth) {
      dispatch(setRequiredModal());
      return dispatch(openAuthModal());
    }

    return push(`${asPath}/${lessons?.lessons?.[0]?.slug}`);
  };

  return (
    <div className="max-w-screen mx-auto my-7 min-h-screen p-4">
      <div onClick={() => back()} className="inline-flex cursor-pointer items-center justify-start gap-2 font-semibold">
        <ArrowLeftIcon /> {t('common.ortga_qaytish')}
      </div>
      <div className="mt-4 p-2 lg:p-0">
        <div className="space-y-4">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
            <FirstSection course={course} />
          </div>
          <Visible if={!isLoading} else={<div className="sm:h-120 h-48 w-full animate-pulse rounded-xl bg-gray-200" />}>
            <div className="relative cursor-pointer" onClick={onEnterLesson}>
              <div onClick={e => e.stopPropagation()}>
                <VideoPlayer
                  src={lessons?.lessons?.[0]?.source as string}
                  className="sm:!h-120 !h-48 rounded-xl object-cover"
                  controls
                  muted
                />
              </div>

              <div className="absolute inset-0" onClick={() => push(`${asPath}/${lessons?.lessons?.[0]?.slug}`)} />
            </div>
          </Visible>
          <Visible
            if={isLoading}
            else={
              <CourseContents
                stats={{ duration: lessons?.duration, lesson_count: lessons?.lessons_count }}
                lessons={lessons?.lessons}
                modules={lessons?.modules}
                type={lessons?.type}
              />
            }
          >
            <Skeleton />
          </Visible>
          <Visible if={!lessons?.is_bought}>
            <Payment price={course?.price} discountPrice={course?.discount_price} />
          </Visible>
        </div>
      </div>
    </div>
  );
};
